import React from "react";
import { useStateContext } from "../contexts/ContextProvider";

const CustomButton = ({
  color = "white",
  size,
  text,
  borderRadius = "10px",
  onClick,
  padding,
  margin = "6px",
  disabled,
  loadingText = "Loading...",
}) => {
  const { currentColor } = useStateContext();
  return (
    <button
      type="button"
      style={{
        backgroundColor: disabled ? "gray" : currentColor,
        color,
        borderRadius,
        padding,
        margin,
      }}
      disabled={disabled}
      className={`text-${size} pt-2 pb-2 pl-3 pr-3 hover:drop-shadow-xl transition disabled:cursor-not-allowed`}
      onClick={onClick}
    >
      {disabled ? loadingText : text}
    </button>
  );
};

export default CustomButton;
